import { dataFetcher } from 'core/services/requestHandler';   

const saveIncentive = async (data = {}, config = {}) => {
  return dataFetcher('incentives', data, {method: 'POST', ...config});
};

const getIncentives = async (data = {}, config = {}) => {
  return dataFetcher('incentives', data, {...config});
};


export { saveIncentive, getIncentives };
